<template lang="pug">
validation-observer.analise(ref='validation' tag='div').card-collapse
  div.analise(v-if="despachoAtual !== null")
    template(slot="separate")
      el-card(shadow="hover")
        app-despachos(
          :idProcesso="idProcesso"
          :data="dadosCadastro",
          @getDownload="getDownload",
        )
    app-pdf-viewer(
      :bytes="arrayBytes"
      )
    div.extra-margin-top(v-if="acoesRadio.length")
      validation-observer.flex-around(ref='validationTitulo' tag='div')
        app-radios-tramitacao(
          :radios="acoesRadio",
          :isDecisao="isDecisao",
          @changeRadio="changeRadio",
          :radioInicial="despachoAtual.acao",
        )

      div(v-if="isRevisao")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label.input-text-editor(label="Despacho")
          app-editor-texto.input(
            @onTextChange="onTextChange",
            v-model="despachoAtual.textoDespacho",
            :class="{'erro' : errors.length}"
            ref="editorTexto"
          )
          span.help.erro {{ errors[0] }}
        app-anexo(
          :id="'upload-anexo-despacho'",
          @uploadFile="uploadFile",
          :files="despachoAtual.documentos",
          @removeFile="removeFile"
          @downloadDocumentoCadastro="downloadDocumentoCadastro",
          :tipoExibir="'ANEXO_ANALISE'"
        )

</template>

<script>
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppAnaliseHeader from '../components/shared/AppAnaliseHeader'
import acaoProcesso from '@/constants/acaoProcesso'
import AppCadastraTituloCertidao from '@/screens/analise/components/AppCadastraTituloCertidao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDespachos from '@/components/AppDespachos'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppAnexo from '@/components/AppAnexo'
import AppLabel from '@/components/AppLabel'
import AppPdfViewer from '@/components/AppPDFViewer'
import { mapActions } from 'vuex'

export default {
  props: {
    idProcesso: {
      type: [Number, String]
    },
    idTitulo: {
      type: Number
    },
    tipo: {
      type: String,
      default: acaoProcesso.EMITIR_OFICIO
    },
    urlOrigem: {
      type: String,
      default: 'CAIXA_ENTRADA'
    },
    isValidacao: {
      type: Boolean,
      default: true
    },
    tipoDespacho: {
      type: String,
      default: 'OFICIO_CCR'
    },
    despacho: {
      type: Object
    }
  },

  mixins: [AppNotificacao],

  components: {
    AppAnaliseHeader,
    AppCadastraTituloCertidao,
    AppDespachos,
    AppRadiosTramitacao,
    AppEditorTexto,
    AppAnexo,
    AppLabel,
    AppPdfViewer
  },

  data () {
    return {
      active: 0,
      arrayBytes: [],
      bytes: null,
      despachoAtual: null,
      totalPdfs: 0,
      despachos: null,
      dadosCadastro: null,
      showTitulo: false,
      isDecisao: false,
      acoesRadio: [],
      radios: [],
      action: 'FINALIZAR',
      titulo: '',
      radio: true,
      podeFinalizarTitulo: true,
      hasClickFinalizar: true,
      back: false,
      acao: ''
    }
  },

  async mounted () {
    await this.init()
  },

  computed: {
    primeiroDocumento () {
      if (this.idTitulo) {
        return this.despachos.find(despacho => despacho.id === this.idTitulo)
      }
      return this.despachoAtual
    }
  },

  methods: {
    ...mapActions({
      getArrayTituloByDespachoId: 'despacho/getArrayTituloByDespachoId',
      tarefa: 'processo/tarefa',
      getDespachosByProcessoETipo: 'despacho/findByFilter',
      iniciaAnaliseCcr: 'processo/iniciaAnaliseCcr',
      confirmarDadosCertidoes: 'despacho/confirmarDadosCertidoes',
      validarTituloCertidao: 'despacho/validarTituloCertidao',
      finalizarDespacho: 'despacho/finalizar',
      getArrayTituloByProcessoId: 'despacho/getArrayTituloByProcessoId',
      getOficioCcrByProcessoId: 'despacho/getOficioCcrByProcessoId'
    }),
    changeRadio (value) {
      this.$emit('changeRadio', value)
      this.acao = value.acao
    },
    cancelar () {
      this.confirmBox(
        `Ao cancelar a ${this.tipoEmissao}, ${this.$messages.CANCELAR_EMISSAO_TITULO_CERTIDAO}`,
        this.$messages.TITULO_WARNING,
        () => {
          if (
            this.despachoAtual.processo.status ===
            'AGUARDANDO_CONFERENCIA_CERTIDAO'
          ) {
            this.$router.push({
              name: 'AGUARDANDO_VALIDACAO_ANALISE'
            })
          } else {
            this.$router.back()
          }
        },
        () => {}
      )
    },

    async init () {
      this.radios = await this.tarefa({ processo: this.idProcesso })
      this.acoesRadio = this.radios.acoes.filter((value, index, arr) => {
        return value.nome !== 'Retornar setor'
      })
      const oficio = await this.getOficioCcrByProcessoId(this.idProcesso)
      this.arrayBytes = Array.from(Buffer.from(oficio, 'base64'))
      this.despachos = [this.despacho]
      this.despachoAtual = this.despachos[0]
      this.totalPdfs = this.despachos.length
      this.bytes = this.arrayBytes[0].bytes
      if (this.isCertidao) {
        this.despachos.forEach(despacho => {
          if (!despacho.validado) {
            this.podeFinalizarTitulo = false
          }
        })
      }
    },
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    changeRadioDespacho (value) {
      this.action = value.acao
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    async confirmarDados () {
      const routeName = this.isValidacao
        ? 'AGUARDANDO_VALIDACAO_ANALISE'
        : 'EM_ANALISE'
      try {
        await this.confirmarDadosCertidoes(this.idProcesso)
        this.$router.push({
          name: routeName
        })
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Processo encaminhado com sucesso'
        )
      } catch (e) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
      }
    },

    editarTituloCertidao () {
      this.$router.push({
        name: 'continuar-emissao-titulo',
        params: {
          despachoEdicao: this.despachoAtual,
          idProcesso: this.idProcesso,
          tipo: acaoProcesso.CONFERENCIA_TITULO,
          urlOrigem: `conferencia-certidao/${this.idProcesso}`
        }
      })
    },

    alterarStatusTituloCertidao (val) {
      this.validarTituloCertidao(this.despachoAtual.id)
      this.verificaPodeFinalizarTitulo()
    },

    verificaPodeFinalizarTitulo () {
      this.podeFinalizarTitulo = true
      this.despachos.forEach(despacho => {
        if (!despacho.validado) {
          this.podeFinalizarTitulo = false
        }
      })
    },

    async finalizar () {
      if (this.isRevisao) {
        const valido = await this.$refs.validation.validate()
        if (!valido) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERROS_ANALISE
          )
          return
        }
        this.despachoAtual.tipo = 'REVISAO'
      }
      if (!this.isReurb && !this.isCertidao) {
        const valido = await this.$refs.validationTitulo.validate()
        if (!valido) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERROS_ANALISE
          )
          return
        }
      }
      this.confirmBox(
        this.$messages.CONFIRM_EMISSAO_CONFERENCIA_TITULO,
        this.$messages.TITULO_WARNING,
        () => {
          if (this.hasClickFinalizar) {
            this.hasClickFinalizar = false
            this.finalizarDespacho(this.despachoAtual)
              .then(() => {
                this.showNotificacao(
                  this.$messages.TIPO_SUCCESS,
                  this.$messages.TITULO_SUCCESS,
                  this.mensagem
                )
                this.$router.push({
                  name: 'AGUARDANDO_VALIDACAO_ANALISE'
                })
                this.hasClickFinalizar = true
              })
              .catch(() => {
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  'Erro ao conferir Título.'
                )
                this.hasClickFinalizar = true
              })
          }
        },
        () => {}
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.flex-around {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.input-text-editor {
  margin-top: 30px;
}

.center {
  display: flex;
  justify-content: center;
}
.card-collapse {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/oficio/ConfirmarDados.vue